import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Aries from "../Assets/Images/section5-1.png";
import Taurus from "../Assets/Images/section5-2.png";
import Gemini from "../Assets/Images/section5-3.png";
import Cancer from "../Assets/Images/section5-4.png";
import Leo from "../Assets/Images/section5-5.png";
import Virgo from "../Assets/Images/section5-6.png";
import Libra from "../Assets/Images/section5-7.png";
import Scorpio from "../Assets/Images/section5-8.png";
import Sagittarius from "../Assets/Images/section5-9.png";
import Capricorn from "../Assets/Images/section5-10.png";
import Aquarius from "../Assets/Images/section5-11.png";
import Pisces from "../Assets/Images/section5-12.png";
import Chakra from "../Assets/Images/section5-chakar.png";

const zodiacSigns = [
  { name: "Aries", img: Aries, description: "Aries are known for their energetic and enthusiastic nature. They are natural leaders and always ready for a challenge." },
  { name: "Taurus", img: Taurus, description: "Taurus individuals are grounded and reliable. They appreciate the finer things in life and enjoy a sense of stability." },
  { name: "Gemini", img: Gemini, description: "Geminis are curious and adaptable. They are excellent communicators and enjoy social interactions." },
  { name: "Cancer", img: Cancer, description: "Cancers are nurturing and emotional. They value family and close relationships above all else." },
  { name: "Leo", img: Leo, description: "Leos are confident and charismatic. They love being the center of attention and have a flair for the dramatic." },
  { name: "Virgo", img: Virgo, description: "Virgos are analytical and detail-oriented. They are practical and strive for perfection in everything they do." },
  { name: "Libra", img: Libra, description: "Libras are diplomatic and fair-minded. They seek balance and harmony in all aspects of their lives." },
  { name: "Scorpio", img: Scorpio, description: "Scorpios are passionate and intense. They are deeply emotional and value honesty and loyalty." },
  { name: "Sagittarius", img: Sagittarius, description: "Sagittarians are adventurous and optimistic. They love to travel and explore new cultures." },
  { name: "Capricorn", img: Capricorn, description: "Capricorns are ambitious and disciplined. They are hard workers and dedicated to achieving their goals." },
  { name: "Aquarius", img: Aquarius, description: "Aquarians are independent and innovative. They are progressive thinkers and value individuality." },
  { name: "Pisces", img: Pisces, description: "Pisces are compassionate and intuitive. They are artistic and deeply connected to their emotions." },
];

export default function ZodiacSection() {
  const [rotate, setRotate] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setRotate(window.scrollY * 0.2);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="relative bg-black text-white py-12 px-6">
      <motion.h2
        className="text-4xl font-bold text-center mb-6"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Horoscope For Zodiac Sign
      </motion.h2>
      <p className="text-center text-white max-w-2xl mx-auto mb-8">
        Discover your daily horoscope and gain insights into your life's journey.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-4xl mx-auto relative z-10">
        {zodiacSigns.map((sign, index) => (
          <motion.div
            key={index}
            className="p-4 border border-gray-600 rounded-lg text-center bg-gray-800 hover:bg-blue-900"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.5 }}
          >
            <img src={sign.img} alt={sign.name} className="w-16 mx-auto mb-3" />
            <h3 className="text-xl font-semibold mb-2">{sign.name}</h3>
            <button 
              className="px-3 py-1 bg-purple-600 text-white rounded text-sm mt-2 hover:bg-purple-700 transition"
              onClick={() => navigate("/about")}
            >
              Learn More
            </button>
          </motion.div>
        ))}
      </div>

      <motion.img
        src={Chakra}
        alt="Chakra"
        className="absolute right-10 top-10 w-60 opacity-40"
        animate={{ rotate: rotate }}
        transition={{ ease: "linear", duration: 0.2 }}
      />
    </div>
  );
}
